import React, { useState, useCallback, useMemo, useContext } from 'react';
import styled from 'styled-components';
import useMainProjects, { CREATE_NEW_MAIN_PROJECT } from '@ubeya/shared/hooks/account/useMainProjects';
import ConfigContext from '../../../contexts/ConfigContext';
import DropDown from '../../DropDown';
import CheckBox from '../../CheckBox';
import FilterLayout from '../FilterLayout';
import { TextWithTooltip } from '../../Tooltip';

const MainEventFilterLabelText = styled(TextWithTooltip)`
  max-width: 200px;
`;

const MainEventFilter = ({ defaultValue, handleClose, onApply, search, onChange, hideLayout = false }) => {
  const { t } = useContext(ConfigContext);
  const { mainProjectOptions } = useMainProjects({ timeRange: undefined });
  const [values, setValues] = useState(defaultValue || []);

  const options = useMemo(() => (mainProjectOptions || []).filter((opt) => opt.value !== CREATE_NEW_MAIN_PROJECT), [
    mainProjectOptions
  ]);

  const filteredOptions = useMemo(
    () =>
      search
        ? options.filter(
            ({ label }) =>
              t('mainEvent').toLowerCase().includes(search.toLowerCase()) ||
              label.toLowerCase().includes(search.toLowerCase())
          )
        : options,
    [options, search, t]
  );

  const handleChange = useCallback(
    (value) => {
      const newValues = values.includes(value) ? values.filter((item) => item !== value) : [...values, value];
      setValues(newValues);
      onChange?.(newValues);
    },
    [onChange, values]
  );

  if (!filteredOptions.length) {
    return null;
  }

  return (
    <FilterLayout
      name={t('mainEvent')}
      handleClose={handleClose}
      onApply={() => onApply(values)}
      hideLayout={hideLayout}>
      {filteredOptions.map(({ value, label }) => (
        <DropDown.Item key={value}>
          <CheckBox name={`main-event-${value}`} value={values.includes(value)} onChange={() => handleChange(value)}>
            <MainEventFilterLabelText>{label}</MainEventFilterLabelText>
          </CheckBox>
        </DropDown.Item>
      ))}
    </FilterLayout>
  );
};

export default MainEventFilter;
